import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Search } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { fileUrl } from "../uploads";
import { STAGES } from "../mock";

export default function Articulos() {
  const { articles } = useStore();
  const [filter, setFilter] = useState("todos");
  const [query, setQuery] = useState("");

  const filtered = articles.filter((a) => {
    const byStage = filter === "todos" || a.stage === filter;
    const byQuery =
      a.title.toLowerCase().includes(query.toLowerCase()) ||
      a.excerpt.toLowerCase().includes(query.toLowerCase());
    return byStage && byQuery;
  });

  return (
    <div className="animate-fade-in">
      <section className="bg-gradient-to-b from-amber/30 to-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20 text-center">
          <span className="font-sans text-xs uppercase tracking-[0.2em] text-terracotta">
            Acceso gratuito · Sin registro
          </span>
          <h1 className="font-serif text-5xl md:text-6xl text-plum mt-3">
            Artículos
          </h1>
          <p className="font-body text-lg text-ink/65 mt-4 max-w-2xl mx-auto">
            Contenido cuidado para acompañarte en cada etapa. Léelos libremente,
            cuando quieras.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row gap-4 md:items-center md:justify-between mb-10">
          <div className="flex flex-wrap gap-2">
            {[{ id: "todos", title: "Todos" }, ...STAGES].map((s) => (
              <button
                key={s.id}
                onClick={() => setFilter(s.id)}
                className={`font-sans text-sm px-5 py-2.5 rounded-full transition-colors ${
                  filter === s.id
                    ? "bg-plum text-cream"
                    : "bg-white text-ink/70 border border-amber/40 hover:border-plum/40"
                }`}
              >
                {s.title}
              </button>
            ))}
          </div>
          <div className="relative w-full md:w-72">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/40" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Buscar artículo..."
              className="w-full font-body bg-white border border-amber/40 rounded-full pl-11 pr-4 py-2.5 text-sm outline-none focus:border-plum transition-colors"
            />
          </div>
        </div>

        {filtered.length === 0 ? (
          <p className="text-center font-body text-ink/50 py-20">
            No hay artículos que coincidan con tu búsqueda.
          </p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
            {filtered.map((a) => (
              <Link
                key={a.id}
                to={`/articulos/${a.id}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div className="h-52 overflow-hidden">
                  <img
                    src={fileUrl(a.cover)}
                    alt={a.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <span className="font-sans text-[11px] uppercase tracking-[0.15em] text-terracotta">
                      {a.stage}
                    </span>
                    <span className="flex items-center gap-1 font-body text-xs text-ink/45">
                      <Clock size={13} /> {a.readTime} min
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl text-plum mt-2 leading-tight group-hover:text-terracotta transition-colors">
                    {a.title}
                  </h3>
                  <p className="font-body text-ink/65 text-sm mt-3 leading-relaxed line-clamp-3">
                    {a.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
